var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import { desktopBreakpoint } from '../../responsive';
import { variantMapping } from './variant-mapping';
var DEFAULT_FONT_WEIGHT = theme.typography.font.inter.weight.regular;
var DEFAULT_COLOR = theme.colors.tfwBlack99;
// Memoize the generateStyles function to avoid recalculations
var generateStyles = function (props) {
    var variant = props.variant, _a = props.color, color = _a === void 0 ? 'tfwBlack99' : _a, _b = props.fontWeight, fontWeight = _b === void 0 ? 'regular' : _b, _c = props.whiteSpace, whiteSpace = _c === void 0 ? 'normal' : _c, textDecoration = props.textDecoration;
    var variantStyle = variantMapping[variant];
    var fontSize = variantStyle.fontSize, fontFamily = variantStyle.fontFamily, defaultFontWeight = variantStyle.fontWeight, lineHeight = variantStyle.lineHeight, letterSpacing = variantStyle.letterSpacing, scaleFactor = variantStyle.scaleFactor;
    var resolvedFontWeight = typeof fontWeight === 'number'
        ? fontWeight
        : theme.typography.font.inter.weight[fontWeight] || defaultFontWeight || DEFAULT_FONT_WEIGHT;
    return "\n        font-size: " + fontSize + ";\n        font-family: " + fontFamily + ";\n        font-weight: " + resolvedFontWeight + ";\n        color: " + (theme.colors[color] || DEFAULT_COLOR) + ";\n        white-space: " + whiteSpace + ";\n        overflow: hidden;\n        text-overflow: ellipsis;\n        -webkit-font-smoothing: antialiased;\n        " + (lineHeight ? "line-height: " + lineHeight + ";" : '') + "\n        " + (textDecoration ? "text-decoration: " + textDecoration + ";" : '') + "\n        \n        @media only screen and (min-width: " + desktopBreakpoint.min + "px) {\n            font-size: calc(" + fontSize + " * " + scaleFactor + ");\n            " + (lineHeight ? "line-height: calc(" + lineHeight + " * " + scaleFactor + ");" : '') + "\n        }\n    ";
};
// Memoize the creation of styled components
var createStyledComponent = function (elementType) {
    return styled(elementType)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n    "], ["\n        ", "\n    "])), generateStyles);
};
// Predefine and memoize all possible styled components
var components = {
    span: memo(createStyledComponent('span')),
    p: memo(createStyledComponent('p')),
    h1: memo(createStyledComponent('h1')),
    h2: memo(createStyledComponent('h2')),
    h3: memo(createStyledComponent('h3')),
    h4: memo(createStyledComponent('h4')),
    h5: memo(createStyledComponent('h5')),
    h6: memo(createStyledComponent('h6')),
    div: memo(createStyledComponent('div')),
    label: memo(createStyledComponent('label')),
};
// Memoized Typography component
var Typography = memo(React.forwardRef(function (props, ref) {
    var _a = props.element, element = _a === void 0 ? 'span' : _a, variant = props.variant, color = props.color, fontWeight = props.fontWeight, whiteSpace = props.whiteSpace, textDecoration = props.textDecoration, children = props.children, id = props.id;
    // Memoize the component selection to avoid recreating it on every render
    var Component = useMemo(function () { return components[element]; }, [element]);
    return (React.createElement(Component, { ref: ref, variant: variant, color: color, fontWeight: fontWeight, whiteSpace: whiteSpace, textDecoration: textDecoration, id: id }, children));
}));
Typography.displayName = 'Typography';
export default Typography;
var templateObject_1;
